<template>
  <div class="product_wrap">
    <div class="product_content">
      <div class="container">
        <breadcrumbs :dom="crumbsItem" />
        <div class="row">
          <div class="col-xl-9">
            <div class="title_item posr">
              <div class="row">
                <div class="col-sm-9">
                  <h2>{{ areaOption.ClassTitle }}</h2>
                </div>
              </div>
              <div class="texthtml" v-html="areaOption.ClassContent"></div>
              <div class="productRegistration">
                <form action="">
                  <div class="county">
                    <!-- 暫時隱藏 -->
                    <!-- <h3>選擇區域</h3>
                                        <div class="errors_box">
                                            <span>{{ errors.first(radioname) }}</span>
                                        </div>
                                        <div class="col-12">
                                            <div class="row countyItem">
                                                <div class="col-4 col-md-2" v-for="(area, index) in areaOption.ClassArea" v-bind:key="index">
                                                    <input v-model="selectedArea" :id="radioname + '_' + index" type="radio" :name="radioname" :value="area.AreaID" v-validate="'required'">
                                                    <label :for="radioname + '_' + index" class="posr">{{ area.AreaName }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <hr> -->
                    <h3>選擇上課地點</h3>
                    <div class="errors_box">
                      <span>{{ errors.first(radionameArea) }}</span>
                    </div>
                    <div class="col-12">
                      <div class="row countyArea">
                        <div
                          class="col-6 col-sm-3"
                          v-for="(location, index) in locationOption"
                          v-bind:key="index"
                        >
                          <div class="row">
                            <div class="col">
                              <input
                                @click="
                                  setSelectedDate(location.FirstStartDate),
                                    setSelectedInfo(location)
                                "
                                v-model="branchRoomID"
                                :id="radionameArea + '_' + index"
                                type="radio"
                                :name="radionameArea"
                                :value="location.BranchRoomID"
                                v-validate="'required'"
                              />
                              <label
                                :for="radionameArea + '_' + index"
                                class="posr"
                              >
                                {{ location.AreaName }}
                              </label>
                            </div>
                            <!-- <div class="col-auto col-sm-9"> -->
                            <!-- <label :for="radionameArea + '_' + index" class="posr noArea">{{ location.BranchAddress }}</label> -->
                            <!-- </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="store_info pb-4" v-if="storeInfo.address">
                    <h3>上課地點</h3>
                    <div class="row">
                      <div class="col-auto">
                        <img
                          :src="require('@/assets/images/icon/icon_map_16.svg')"
                        />
                      </div>
                      <div class="col col-md-auto">
                        <p>{{ storeInfo.address }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-auto">
                        <img
                          :src="
                            require('@/assets/images/icon/icon_phone_16.svg')
                          "
                        />
                      </div>
                      <div class="col col-md-auto">
                        <p>{{ storeInfo.phone }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="county choose_date">
                    <div class="row">
                      <div class="col-lg-9">
                        <h3>選擇日期</h3>
                        <div class="errors_box">
                          <span>{{ errors.first('selectedDate') }}</span>
                        </div>
                        <div class="errors_box">
                          <span>{{ errors.first(chooseTimeName) }}</span>
                        </div>
                        <div class="row" v-if="branchRoomID">
                          <div class="col-md-6">
                            <div class="date_box">
                              <datepicker
                                @changedMonth="changedMonth"
                                :inline="true"
                                v-model="selectedDate"
                                :highlighted="highlighted"
                                v-validate="'required'"
                                name="selectedDate"
                              ></datepicker>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="choose_time_box">
                              <div class="row">
                                <div
                                    class="col-12"
                                    v-if="timeOption.isAllDayFull"
                                >
                                  <p class="pageTextRed">報名額滿</p>
                                </div>
                                <div
                                  class="col-12"
                                  v-if="!timeOption.ClassTimeSlot && !timeOption.isAllDayFull"
                                >
                                  <p class="pageTextRed">本日未開課</p>
                                </div>
                                <div
                                    v-if="!timeOption.isAllDayFull"
                                  class="col-12"
                                  v-for="(timeSlot,
                                  index) in filteredTimeOptions"
                                  v-bind:key="index"
                                >
                                  <input
                                    :id="chooseTimeName + '_' + index"
                                    type="radio"
                                    :name="chooseTimeName"
                                    v-validate="'required'"
                                    v-model="classBranchId"
                                    :value="timeSlot.ClassBranchID"
                                  />
                                  <label
                                    :for="chooseTimeName + '_' + index"
                                    class="posr"
                                  >
                                    {{ timeSlot.TimeSlot }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <h3>報名{{ this.product.classUnit }}數</h3>
                        <div class="errors_box">
                          <span>{{ errors.first('quantity') }}</span>
                        </div>
                        <number-input
                          @input.native="quantityInput($event)"
                          v-if="classBranchId && !timeOption.isAllDayFull"
                          controls
                          :min="min"
                          :max="max"
                          v-model="quantity"
                          placeholder="人數"
                          v-validate="'required|min_value:1'"
                          name="quantity"
                          rounded
                        ></number-input>
                      </div>
                    </div>
                  </div>
                  <div class="form_btnBox">
                    <div class="row justify-content-between text-center">
                      <div class="col-sm-3 col-lg-2 mb-3">
                        <router-link :to="toPrevious" class="link hoverFill">
                          &lt; 回上一頁
                        </router-link>
                      </div>
                      <div class="col-sm-8">
                        <div class="row">
                          <div class="col-6">
                            <a
                              href="javascript:void(0)"
                              @click="checkBeforeAddToCart(1)"
                              class="link hoverFill"
                            >
                              加入購物車
                            </a>
                          </div>
                          <div class="col-6">
                            <a
                              href="javascript:void(0)"
                              @click="checkBeforeAddToCart(2)"
                              class="link hoverFill"
                            >
                              前往結帳
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="aside_right">
              <div class="price">
                <div class="row">
                  <div class="col-7 col-sm-4 col-lg-10">
                    <div class="row">
                      <template v-if="price.EarlyBirdDiscount">
                        <div class="col-5">
                          <p class="justify">早鳥優惠</p>
                        </div>
                        <div class="col-7">
                          <p class="num">
                            <span class="pageTextRed">
                              {{ price.EarlyBirdDiscount | currency }}
                            </span>
                            起
                          </p>
                        </div>
                      </template>
                      <div class="col-5">
                        <p class="justify">定價</p>
                      </div>
                      <div class="col-7">
                        <p class="num">
                          <span class="pageTextBlack">
                            {{ price.FixedPrice | currency }}
                          </span>
                          起
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sponsor">
                <div class="row">
                  <div class="col-xl-4">
                    <img
                      :src="require(`@/assets/images/icon/time_small.svg`)"
                    />
                    <h4>開課日期</h4>
                  </div>
                  <div class="col-xl-8">
                    <p>{{ price.ClassDate }}</p>
                  </div>
                  <div class="col-xl-4">
                    <img
                      :src="require(`@/assets/images/icon/suitable_small.svg`)"
                    />
                    <h4>適用對象</h4>
                  </div>
                  <div class="col-xl-8">
                    <p>{{ price.SuitableObject }}</p>
                  </div>
                  <div class="col-xl-4">
                    <img
                      :src="require(`@/assets/images/icon/home_small.svg`)"
                    />
                    <h4>主辦單位</h4>
                  </div>
                  <div class="col-xl-8">
                    <p>{{ price.Organizers }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Recommend :class-id="areaOption.ClassID" />

    <!-- Modal -->
    <div>
      <b-modal
          modal-class="checkBeforeAddToCart"
          no-close-on-backdrop
          v-model="modalShow"
          hide-footer
      >『此課程已加入購物車，請確認數量是否正確』
        <br>
        <br>
        <br>
        <div class="checkBeforeAddToCartBtn" >
          <div class="row justify-content-center">
            <div class="col-auto">
              <button class="hoverFill" type="button" @click="handleModalCancel()">取消</button>
            </div>
            <div class="col-auto">
              <button class="hoverShallow" type="button" @click="handleModalOk()">確認</button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';
import Breadcrumbs from '@/components/partial/Breadcrumbs';
import ProductItem from '@/components/products/items/Item';
import Recommend from '@/components/products/partials/Recommend';
import Datepicker from 'vuejs-datepicker'; // 日期
import VueNumberInput from '@chenfengyuan/vue-number-input'; // number
import classificationsMixin from '@/mixins/classifications';
import userMixin from '@/mixins/user';
import classApi from '@/api/class';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

import store from '@/store';

Vue.component(VueNumberInput.name, VueNumberInput);

export default {
  mixins: [classificationsMixin, userMixin],
  components: {
    Breadcrumbs,
    ProductItem,
    Datepicker,
    Recommend
  },
  props: ['parentid', 'id'],
  data() {
    return {
      radioname: 'ProductCounty',
      radionameArea: 'ProductArea',
      chooseTimeName: 'time',
      format: 'YYYY/MM/DD',
      selectedDate: null,
      date: new Date(),
      selectedArea: null,
      branchRoomID: null,
      classBranchId: undefined,
      quantity: 1,
      product: {},
      price: {},
      areaOption: {},
      locationOption: [],
      canendarOptions: {},
      monthChanged: false,
      firstIn: true,
      storeInfo: {
        address: null,
        phone: null
      },
      modalShow: false,
      selectedAddToCartType: 1,
    };
  },
  computed: {
    ...mapGetters('cart', ['products']),
    filteredTimeOptions() {
      if(this.timeOption !== undefined && this.timeOption.ClassTimeSlot != undefined && this.timeOption.ClassTimeSlot.length > 0) {
        return this.timeOption.ClassTimeSlot.filter(obj => obj.isFull === false);
      }
      return []
    },
    sameBranchproducts() {
      return this.products.filter(
        product => product.ClassBranchId == this.classBranchId
      );
    },
    currentBranchQuantity() {
      return this.sameBranchproducts.reduce((total, product) => {
        return total + product.quantity;
      }, 0);
    },
    crumbsItem() {
      return [
        {
          text: '首頁',
          to: {
            name: 'home'
          }
        },
        {
          text: this.getClassificationNameById(this.parentid),
          to: {
            name: 'products.index',
            params: {
              id: this.parentid
            }
          }
        },
        {
          text: this.product.ClassTitle,
          to: this.toPrevious
        },
        {
          text: '我要報名',
          active: true
        }
      ];
    },
    toPrevious() {
      return {
        name: 'products.show',
        params: {
          parentid: this.parentid,
          id: this.id
        }
      };
    },
    canendarOption() {
      return _.get(this.canendarOptions, this.dateFormat, []);
    },
    timeOption() {
      let timeOption = this.canendarOption.find(
        option => option.ClassDate == this.selectedDateFormat
      );

      return timeOption ? timeOption : {};
    },
    selectedDateFormat() {
      return this.customFormatter(this.selectedDate);
    },
    dateFormat() {
      return this.customFormatter(this.date, 'YYYY/MM');
    },
    highlighted() {
      return {
        dates: this.canendarOption.map(option => {
          return moment(option.ClassDate).toDate();
        })
      };
    },
    location() {
      let location = this.locationOption.find(
        option => option.BranchRoomID == this.branchRoomID
      );

      return location ? location : {};
    },
    timeSlot() {
      let timeSlot = {};

      for (let key in this.canendarOptions) {
        for (let timeOption of this.canendarOptions[key]) {
          let classTimeSlot = _.get(timeOption, 'ClassTimeSlot', []);

          timeSlot = classTimeSlot.find(
            option => option.ClassBranchID == this.classBranchId
          );

          if (timeSlot) {
            return timeSlot;
          }
        }
      }

      return timeSlot ? timeSlot : {};
    },
    classBranchLimit() {
      return _.get(this.timeSlot, 'ClassBranchLimit', 0);
    },
    classLimit() {
      return _.get(this.timeSlot, 'ClassLimit', 0);
    },
    max() {
      let max = this.classLimit;

      if (this.classBranchLimit > 0 && max > this.classBranchLimit) {
        max = this.classBranchLimit;
      }

      return max;
    },
    min() {
      return this.max ? 1 : 0;
    },
    finalPrice() {
      let finalPrice = _.get(this.price, 'FixedPrice', 0);
      let earlyBirdDiscount = _.get(this.price, 'EarlyBirdDiscount', 0);

      let GroupLimit1 = _.get(this.price, 'GroupLimit1', 0);
      let GroupLimit2 = _.get(this.price, 'GroupLimit2', 0);
      let GroupLimit3 = _.get(this.price, 'GroupLimit3', 0);

      let GroupPrice1 = _.get(this.price, 'GroupPrice1', 0);
      let GroupPrice2 = _.get(this.price, 'GroupPrice2', 0);
      let GroupPrice3 = _.get(this.price, 'GroupPrice3', 0);

      if (earlyBirdDiscount > 0 && earlyBirdDiscount < finalPrice) {
        finalPrice = earlyBirdDiscount;
      }

      let checkGroup = (GroupLimit, GroupPrice) => {
        if (
          GroupLimit > 0 &&
          GroupPrice > 0 &&
          this.quantity >= GroupLimit &&
          finalPrice > GroupPrice
        ) {
          finalPrice = GroupPrice;
        }
      };

      checkGroup(GroupLimit1, GroupPrice1);
      checkGroup(GroupLimit2, GroupPrice2);
      checkGroup(GroupLimit3, GroupPrice3);

      return finalPrice;
    }
  },
  created() {
    window.addEventListener('scroll', this.windowScroll);
    window.addEventListener('resize', this.windowScroll);

    this.getQueryExplanation();
    this.getQueryPrice();
    this.getLocationOption();

    let attributes = {};

    attributes[this.radioname] = '區域';
    attributes[this.radionameArea] = '上課地點';
    attributes[this.chooseTimeName] = '時間';
    attributes['selectedDate'] = '日期';
    attributes['quantity'] = '報名人數';

    const dict = {
      attributes
    };

    this.$validator.localize('zh_TW', dict);
  },
  destroyed() {
    window.removeEventListener('scroll', this.windowScroll);
    window.addEventListener('resize', this.windowScroll);
  },
  watch: {
    selectedArea(val) {
      if (val) {
        this.getLocationOption();
        this.branchRoomID = null;
        this.classBranchId = undefined;
        this.quantity = 1;
        this.selectedDate = null;
      }
    },
    branchRoomID(val) {
      if (val) {
        this.getCanendarOption();
        this.classBranchId = undefined;
        this.quantity = 1;
        // this.selectedDate = null;
      }
    },
    date(val) {
      if (val && this.monthChanged) {
        this.getCanendarOption();
        this.classBranchId = undefined;
        this.quantity = 1;
      }
    },
    classBranchId() {
      this.getQueryPrice();
      this.quantity = 1;
    },
    selectedDate() {
      this.classBranchId = undefined;
      this.quantity = 1;
    },
    filteredTimeOptions: {
      deep: true,
      handler(val) {
        if (val.length > 0) {
          this.classBranchId = val[0].ClassBranchID;
        } else {
          this.classBranchId = undefined;
        }
      }
    }
  },
  methods: {
    setSelectedDate(date) {
      this.firstIn = false;
      date = moment(date).toDate();
      this.selectedDate = date;
      this.date = date;
    },
    setSelectedInfo(data) {
      this.storeInfo.address = data.BranchAddress;
      this.storeInfo.phone = data.BranchTelno;
    },
    quantityInput(e) {
      let val = _.toSafeInteger(e.target.value);
      e.target.value = val;
      this.quantity = val;
    },
    ...mapActions('cart', ['addProductToCart']),
    initUser() {
      this.getQueryPrice();
      this.getLocationOption();

      if (this.selectedArea) {
        this.getLocationOption();
      }

      if (this.branchRoomID) {
        this.getCanendarOption();
      }
    },
    addToCart(type) {
      if (!this.classBranchId) {
        alert('請選擇上課日期。');
        return;
      }
      this.$validator.validateAll().then(result => {
        if (!result) {
          // window.location.href = this.crumbsItem[0].to
          return;
        } else {
          let totalQuantity = this.currentBranchQuantity + this.quantity;

          if (totalQuantity > this.max) {
            alert('報名人數超出限制');
            return;
          }
          if (this.id && this.branchRoomID && this.classBranchId) {
            this.addProductToCart({
              product: {
                id: this.id,
                AreaID: this.selectedArea,
                BranchRoomID: this.branchRoomID,
                ClassBranchId: this.classBranchId,
                title: this.product.ClassTitle,
                organizer: this.price.Organizers,
                address: this.location.BranchAddress,
                date: this.selectedDateFormat,
                time: this.timeSlot.TimeSlot,
                quantity: this.quantity,
                price: this.finalPrice,
                bonusDis: '',
                bonusDisTemp: '',
                enjoyDis: '',
                enjoyDefaultNum: '',
                couponDis: '',
                minusAmount: '',
                payPrice: this.finalPrice,
                disCouponsId: '',
                disCoupons: [],
                ticketNo: '',
                enJoyRes: '',
                balanceEnjoy: '',
                denomination: '',
                bonusDefaultNum: '',
                bonusNumTemp: '',
                isSwitchOn: true,
                couponDisTemp: '',
                ticketNoTemp: '',
                EventMastId: '',
                EventDetlId: '',
                DESCRITPION: '',
                DiscTypePoint: '',
                DscSku: '',
                SkuNoPoint: '',
                SkuNo30: '',
                ReturnSkuNo30: '',
                DiscType30: '',
                Grno30: '',
                rebateName30: '',
                accountType: '',
                copu_type: '',
                SkuNo10: '',
                ReturnSkuNo10: '',
                DiscType10: '',
                Grno10: '',
                rebateName10: '',
                TempSave: {},
                couponInfoTemp: {},
                RbonusPoints:''
              }
            });

            if (type == 1) alert('加入購物車成功');
            else this.$router.push({ name: 'cart.index' });
          } else {
            alert('請填寫完整資料');
          }
        }
      });
    },
    getQueryPrice() {
      if (this.firstIn) {
        this.price = {};
        classApi.queryPrice(
          {
            InitID: this.id,
            ClassBranchID: this.classBranchId
          },
          data => {
            this.price = data ? data : {};
          }
        );
      } else if (this.classBranchId != undefined) {
        this.price = {};
        classApi.queryPrice(
          {
            InitID: this.id,
            ClassBranchID: this.classBranchId
          },
          data => {
            this.price = data ? data : {};
          }
        );
      }
    },
    getQueryExplanation() {
      this.product = {};
      classApi.queryExplanation(
        {
          InitID: this.id
        },
        data => {
          this.product = data ? data : {};
          this.$set(this.product, 'InitID', this.id);
        }
      );
    },
    getAreaOption() {
      this.areaOption = {};
      classApi.areaOption({ InitID: this.id }, data => {
        this.areaOption = data ? data : {};
      });
    },
    getLocationOption() {
      this.locationOption = [];
      classApi.locationOption({ InitID: this.id }, data => {
        this.locationOption = data ? data : [];
      });
    },
    getCanendarOption() {
      let dateFormat = _.clone(this.dateFormat);
      classApi.canendarOption(
        {
          InitID: this.id,
          InquireMonth: this.customFormatter(this.date),
          BranchRoomID: this.branchRoomID
        },
        data => {
          this.$set(this.canendarOptions, dateFormat, data ? data : []);

          // if (data != null && data.length > 0) {
          //     let id = data[0].ClassTimeSlot[0].ClassBranchID;
          //     this.classBranchId = id;
          // } else {
          //     this.classBranchId = undefined;
          // }
          this.monthChanged = false;
        }
      );
    },
    changedMonth(date) {
      if (!(date instanceof Date)) {
        date = _.get(date, 'timestamp');
      }
      this.monthChanged = true;
      this.date = date;
    },
    customFormatter(date, format) {
      if (format) {
        return moment(date).format(format);
      }
      return moment(date).format(this.format);
    },
    windowScroll() {
      let HeaderH = _.get(document.querySelector('header'), 'clientHeight'),
        Crumbs = _.get(document.querySelector('.breadcrumbs'), 'clientHeight'),
        WindowTop = window.pageYOffset,
        WindowWidth = $(window).width(),
        MainH = _.get(document.querySelector('main'), 'clientHeight'),
        FooterH = _.get(document.querySelector('footer'), 'clientHeight'),
        ProRecom = _.get(
          document.querySelector('.product_recommended'),
          'clientHeight'
        );
      // eslint-disable-next-line
      $(document).ready(() => {
        let $asideRight = $('.aside_right'),
          asWidth = $('.aside_right').innerWidth();
        if (WindowWidth > 1200) {
          if (WindowTop >= HeaderH - Crumbs * 2) {
            if (WindowTop >= MainH - HeaderH - $(window).height()) {
              $asideRight.css({
                opacity: '0',
                'pointer-events': 'none'
              });
            } else {
              $asideRight.css({
                opacity: '1',
                'pointer-events': 'auto',
                width: asWidth,
                position: 'fixed',
                top: '14vh',
                'z-index': '2'
              });
            }
          } else {
            $asideRight.removeAttr('style');
          }
        } else {
          if (WindowTop >= MainH - (FooterH + ProRecom) - $(window).height()) {
            $asideRight.css({
              opacity: '0',
              'pointer-events': 'none'
            });
          } else {
            $asideRight.removeAttr('style');
          }
        }
        if (WindowWidth < 1200) {
          if (
            WindowTop >=
            MainH -
              (HeaderH + FooterH) -
              $asideRight.outerHeight(true) -
              $(window).height()
          ) {
            $asideRight.css({
              opacity: '0',
              'pointer-events': 'none'
            });
          }
        }
      });
    },
    handleModalCancel() {
      this.modalShow = false;
    },
    handleModalOk() {
      this.modalShow = false;
      this.addToCart(this.selectedAddToCartType);
    },
    checkBeforeAddToCart(selectedType) {
      this.selectedAddToCartType = selectedType;
      let products = store.getters['cart/products'];
      let classBranchAlreadyInCart = false;
      for(let i in products) {
        if (products[i].ClassBranchId == this.classBranchId) {
          classBranchAlreadyInCart = true;
          break;
        }
      }
      if (classBranchAlreadyInCart === true) {
        this.modalShow = true;
      } else {
        this.addToCart(this.selectedAddToCartType);
      }
    }
  }
};
</script>
